import WidgetCurrencyContainer from './WidgetCurrencyContainer';

export default WidgetCurrencyContainer;
